export default function (s) {
  if (! process.client) { return s }
  const elem = document.createElement('textarea')
  elem.innerHTML = s
  return elem.value
}
